// extracted by css-extract-rspack-plugin
export default {"titleLabel":"F9RiH","disabled":"ww9BC"};